import React from 'react';
import { FlatContentCard } from '@shared/ui/atoms/FlatContentCard';
import { BodySmall } from '@shared/ui/atoms/fonts/Body';
import Colours from '@shared/ui/atoms/Colours';

interface Props {
  children: React.ReactNode;
  weight?: number;
  small?: boolean;
  style?: React.CSSProperties;
}

// Compact blue highlight tile used on the billing page (licences / cost summary).
// Encapsulates the blue05 background, tight padding and dark-blue text.
export function PlanInfoCard({ children, weight, small, style }: Props) {
  return (
    <FlatContentCard backgroundColour={Colours.blue05} style={{ padding: '12px 16px', ...style }}>
      {small
        ? <BodySmall weight={weight} colour={Colours.darkBlue}>{children}</BodySmall>
        : <BodySmall weight={weight} colour={Colours.darkBlue}>{children}</BodySmall>}
    </FlatContentCard>
  );
}
